export const initUser = settings => dispatch =>
  dispatch({ type: 'INIT_USER', payload: settings })
